export default __webpack_public_path__ + "static/news11-e36fecb04376efcb1144e45124ae1329.png";